export default __webpack_public_path__ + "static/media/Level9.3ac063d8.svg";